
import { DefaultState } from 'store/types';

export const LODGING_OPTION_REPORT_EXCEL_REQUEST = 'LODGING_OPTION_REPORT_EXCEL_REQUEST';
export const LODGING_OPTION_REPORT_EXCEL_SUCCESS = 'LODGING_OPTION_REPORT_EXCEL_SUCCESS';
export const LODGING_OPTION_REPORT_EXCEL_FAILURE = 'LODGING_OPTION_REPORT_EXCEL_FAILURE';

export interface LodgingOptionReportExcelParams {
  reportId: string;
};

export type LodgingOptionReportExcelState = DefaultState & {
  contents?: {};
};

interface LodgingOptionReportExcelRequest {
  type: typeof LODGING_OPTION_REPORT_EXCEL_REQUEST;
};

interface LodgingOptionReportExcelSuccess {
  type: typeof LODGING_OPTION_REPORT_EXCEL_SUCCESS,
  contents: {};
}

interface LodgingOptionReportExcelFailure {
  type: typeof LODGING_OPTION_REPORT_EXCEL_FAILURE;
}

export type LodgingOptionReportExcelActionTypes = LodgingOptionReportExcelRequest | LodgingOptionReportExcelSuccess | LodgingOptionReportExcelFailure;